import { SafeError } from '@exodus/errors';
import { ExchangeStatus } from '../modules/constants.js';
import { z } from '@exodus/zod';
import { memoize } from '@exodus/basic-utils';
const createExchangeReport = ({ exchangeStatusAtom, }) => ({
    namespace: 'exchange',
    export: async ({ walletExists } = Object.create(null)) => {
        if (!walletExists)
            return null;
        const data = await exchangeStatusAtom.get();
        if (!data) {
            return null;
        }
        return {
            ...data,
            error: data.error ? SafeError.from(data.error) : null,
            fromAmount: data.fromAmount.toDefaultString({ unit: true }),
            toAmount: data.toAmount.toDefaultString({ unit: true }),
        };
    },
    getSchema: memoize(() => {
        const safeErrorSchema = z.instanceof(SafeError).nullable();
        const exchangeStatusSchema = z.nativeEnum(ExchangeStatus);
        return z
            .object({
            status: exchangeStatusSchema,
            fromAssetName: z.string(),
            toAssetName: z.string(),
            fromAmount: z.string(),
            toAmount: z.string(),
            orderId: z.string().nullable(),
            error: safeErrorSchema,
        })
            .strict()
            .nullable();
    }),
});
const exchangeReportDefinition = {
    id: 'exchangeReport',
    type: 'report',
    factory: createExchangeReport,
    dependencies: ['exchangeStatusAtom'],
    public: true,
};
export default exchangeReportDefinition;
